import { FlashMessageType } from 'types/Shared/FlashMessage'

export const DEFAULT_STYLES = {
  position: 'fixed',
  top: '0',
  width: '100vw',
  minHeight: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  willChange: 'transform, opacity',
  zIndex: '10000',
}

export const ANIMATION = {
  from: {
    opacity: 0,
    transform: 'translate3d(0,-50%,0)',
  },
  enter: {
    opacity: 1,
    transform: 'translate3d(0,0,0)',
  },
  leave: {
    opacity: 0,
    transform: 'translate3d(0,-50%,0)',
  },
}
